import { render, staticRenderFns } from "./musicCode.vue?vue&type=template&id=38d4c9a8&scoped=true&"
import script from "./musicCode.vue?vue&type=script&lang=js&"
export * from "./musicCode.vue?vue&type=script&lang=js&"
import style0 from "./musicCode.vue?vue&type=style&index=0&id=38d4c9a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d4c9a8",
  null
  
)

export default component.exports